import { Box, HStack, Image, Text, VStack } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import IconEco from '../../../../components/SvgIcon/icons/IconEco'
import IconCalendar from '../../../../components/SvgIcon/icons/IconCalendar'
import IconMoto from '../../../../components/SvgIcon/icons/IconMoto'
import IconStore from '../../../../components/SvgIcon/icons/IconStore'
import IconCart from '../../../../components/SvgIcon/icons/IconCart'
import IconBag from '../../../../components/SvgIcon/icons/IconBag'
import IconPorcentaje from '../../../../components/SvgIcon/icons/IconPorcentaje'
import IconCarttime from '../../../../components/SvgIcon/icons/IconCarttime'

export function ItemComponent({
  NombreLocal,
  sEstablecimiento,
  sLocal,
  Clasificacion,
  bEco,
  bRetiroTienda,
  bTiendaOnline,
  bDelivery,
  bSaveProduc,
  bScheduleDelivery,
  bhasConsumeStore,
  bhasPromotions,
}) {
  return (
    <Box w="100%" boxSizing="border-box" padding="0px 10px 0px 10px">
      <HStack
        mb={1}
        w="100%"
        borderRadius="7px"
        backgroundColor="#FFF"
        boxShadow="0px 5px 17px 0px #00000021"
      >
        <Image
          src={`https://assetsamipass.blob.core.windows.net/commerces/${sEstablecimiento}/${sLocal}/logo.png`}
          width="80px"
          height="80px"
          padding={2}
          borderRadius={100}
        />
        <VStack flex={1} alignItems="flex-start" spacing={0}>
          <HStack>
            <Text variant="subtitle2" color="#000000">
              {NombreLocal}
            </Text>
            {bEco && <IconEco />}
          </HStack>
          <Text variant="body3">{Clasificacion}</Text>
          <HStack pt={2}>
            {bScheduleDelivery && <IconCalendar />}
            {bDelivery && <IconMoto />}
            {bhasConsumeStore && <IconStore />}
            {bTiendaOnline && <IconCart />}
            {bRetiroTienda && <IconBag />}
            {bhasPromotions && <IconPorcentaje />}
            {bSaveProduc && <IconCarttime />}
          </HStack>
        </VStack>
      </HStack>
    </Box>
  )
}

ItemComponent.propTypes = {
  NombreLocal: PropTypes.string,
  sEstablecimiento: PropTypes.string,
  sLocal: PropTypes.string,
  Clasificacion: PropTypes.string,
  bEco: PropTypes.bool,
  bRetiroTienda: PropTypes.bool,
  bTiendaOnline: PropTypes.bool,
  bDelivery: PropTypes.bool,
  bSaveProduc: PropTypes.bool,
  bScheduleDelivery: PropTypes.bool,
  bhasConsumeStore: PropTypes.bool,
  bhasPromotions: PropTypes.bool,
}
